<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Article Health</h3>
		</header>
		<div class="card-body">
			<div class="table-responsive">
				<table>
					<thead>
						<tr>
							<th>Rule</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-bind:class="{ 'text-danger': result.result === 300 }" v-for="result in editorHealthChecker.result">
							<td>{{ result.rule }}</td>
							<td class="text-center"
								v-bind:class="{
									'text-success': result.result === 0,
									'text-warning': result.result === 100,
									'text-danger': result.result === 200 || result.result === 300,
								}"
							><i class="fas bg-danger"
								v-bind:class="{
									'fa-check-circle text-success': result.result === 0,
									'fa-info-circle text-warning': result.result === 100,
									'fa-exclamation-circle text-danger': result.result === 200,
									'fa-times-circle text-danger': result.result === 300,
								}"
								v-bind:title="result.message"
							></i></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			editorHealthChecker: {
				type: Object
			}
		},
	}
</script>

<style scoped>

</style>
